import { createAsyncThunk } from "@reduxjs/toolkit";
import apiClient from "../../../services/axois";
import { toast } from "react-toastify";
// this is for demo purpose only / change for further api calls

export const getRoles = createAsyncThunk(
  "roleManagement/getRoles",
  async () => {
    try {
      let url = `/roles`;
      const response = await apiClient.get(url);
      return response?.data?.result;
    } catch (error) {
      console.error("builder function error:", error);
      throw error;
    }
  }
);

export const getallPermissions = createAsyncThunk(
  "roleManagement/getallPermissions",
  async () => {
    try {
      let url = `/permissions`;
      const response = await apiClient.get(url);
      return response?.data?.result;
    } catch (error) {
      console.error("builder function error:", error);
      throw error;
    }
  }
);

export const getPermissionsForRole = createAsyncThunk(
  "roleManagement/getPermissionsForRole",
  async (roleId) => {
    try {
      const response = await apiClient.get(`/permissions/${roleId}`);
      return response?.data?.result;
    } catch (error) {
      console.error("builder function error:", error);
      throw error;
    }
  }
);

export const addPermissions = createAsyncThunk(
  "roleManagement/addPermissions",
  async ({ data, navigate }) => {
    try {
      const permissionData = {
        permission: data.permission,
        role_id: data.roleId,
        isAdmin:data.isAdmin,
        isMobileAccess: data.isMobileAccess
      }

      const response = await apiClient.post(`/permission`, permissionData);

      navigate('/role-management')

      if (response.status) {
        toast.success("Your details have been updated successfully", {
          className: 'custom-toast-success',
          progressStyle: { background: '#ffffff' },
        })
      }

    } catch (error) {
      // console.error("builder function error:", error);
      toast.error(error.response.data.message, {
        className: 'custom-toast-error',
        progressStyle: { background: '#C53C43' },
      })
      throw error;
    }
  }
);

export const addNewRoleWithPermissions = createAsyncThunk(
  "roleManagement/addNewRoleWithPermissions",
  async ({ data, navigate }) => {
    try {
      const permissionData = {
        roleName: data.roleName,
        isMobileAccess: data.isMobileAccess,
        isAdmin: data.isAdmin,
        permissions: data.permissions
      }
      const response = await apiClient.post(`/role-with-permissions`, permissionData);
      navigate('/role-management')

      if (response.status) {
        toast.success(response.data.message, {
          className: 'custom-toast-success',
          progressStyle: { background: '#ffffff' },
        })
      }

    } catch (error) {
      console.error("builder function error:", error);
      toast.error(error.response.data.message, {
        className: 'custom-toast-error',
        progressStyle: { background: '#C53C43' },
      })
      throw error;
    }
  }
);

